import {
  FETCH_CURRENT_USER_STARTED,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_CURRENT_USER_FAILURE,
} from './actions.js';

export const initialState = {
  currentUser: null,
  userRole: null,
  allowedSpecIds: [],
  userEnvironment: null,
  defaultSpecId: null,
  authLoading: false,
  authError: null,
};

const reducers = {
  [FETCH_CURRENT_USER_STARTED]: (state) => {
    return state
      .set('authLoading', true)
      .set('authError', null);
  },
  [FETCH_CURRENT_USER_SUCCESS]: (state, action) => {
    const user = action.payload;
    console.log('[AUTH REDUCER] FETCH_CURRENT_USER_SUCCESS payload:', user);
    console.log('[AUTH REDUCER] Setting userRole to:', user?.role);
    return state
      .set('authLoading', false)
      .set('authError', null)
      .set('currentUser', user)
      .set('userRole', user?.role || null)
      .set('allowedSpecIds', user?.allowedSpecIds || [])
      .set('userEnvironment', user?.environmentId
        ? { id: user.environmentId, name: user.environmentName }
        : null)
      .set('defaultSpecId', user?.defaultSpecId || null);
  },
  [FETCH_CURRENT_USER_FAILURE]: (state, action) => {
    return state
      .set('authLoading', false)
      .set('authError', action.payload);
  },
};

export default reducers;
